export const unleashConfig = {
  url: 'https://us.app.unleash-hosted.com/usee0010/api/frontend',
  clientKey:
    process.env.NODE_ENV === 'production'
      ? '*:production.v2_-a-Fr4blTtHkJakqBMVxMg_chsIcJ5nEDr12SIXos4B-eACc9BAPhboQEVJjuDcKlw'
      : '*:development.v2_AJq3G9IzO0yXQLgNEBezrg_eN_W1gLKsoeei6Yrm3lYDRqYalJMvR3mV3gKpPxAygU',
  refreshInterval: 60,
  appName: 'connect',
};
